function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import React from 'react';
import 'isomorphic-fetch';
import ReactHOC from '../../../common/react-hoc';
import { API_CONFIG } from './rest-api-config';
import HearingTestInvitationConfirmation from './subitems/react-invitation-confirmation';
import HearingTestInvitationConfirmationErrors from './subitems/react-invitation-confirmation-errors';
import HearingTestInvitationFormSubmitted from './subitems/react-invitation-form-submitted';
import HearingTestInvitationForm from './subitems/react-invitation-form';
var HearingTestInvitationApp = /*#__PURE__*/function (_React$Component) {
  function HearingTestInvitationApp(props) {
    var _this;
    _classCallCheck(this, HearingTestInvitationApp);
    _this = _callSuper(this, HearingTestInvitationApp, [props]);
    _this.state = {
      isSubmitted: false,
      isConfirmationToken: false,
      isConfirmationError: false,
      confirmationData: null
    };
    _this.language = document.documentElement.lang || 'en';
    return _this;
  }
  _inherits(HearingTestInvitationApp, _React$Component);
  return _createClass(HearingTestInvitationApp, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      this.validateConfirmationToken();
    }
  }, {
    key: "validateConfirmationToken",
    value: function validateConfirmationToken() {
      var _this2 = this;
      var confirmationToken = HearingTestInvitationApp.getUrlParameter('confirmationToken');
      var language = this.language;
      if (confirmationToken !== null) {
        fetch("".concat(API_CONFIG.URL, "confirminvitation/").concat(confirmationToken, "/").concat(language), {
          headers: {
            'Content-Type': 'application/json'
          }
        }).then(function (response) {
          if (response.status !== 200) {
            _this2.setState({
              isConfirmationError: true
            });
          }
          _this2.setState({
            isConfirmationToken: true
          });
          return response.json();
        }).then(function (json) {
          _this2.setState({
            confirmationData: json
          });
        });
      }
    }
  }, {
    key: "submitCallback",
    value: function submitCallback(isSubmitted) {
      this.setState({
        isSubmitted: isSubmitted
      });
    }
  }, {
    key: "renderConfirmationOrError",
    value: function renderConfirmationOrError() {
      var _this$state = this.state,
        isConfirmationError = _this$state.isConfirmationError,
        confirmationData = _this$state.confirmationData;
      if (isConfirmationError) {
        return /*#__PURE__*/React.createElement(HearingTestInvitationConfirmationErrors, {
          data: this.props.settings,
          apiResponse: confirmationData
        });
      }
      return /*#__PURE__*/React.createElement(HearingTestInvitationConfirmation, {
        data: this.props.settings,
        apiResponse: confirmationData
      });
    }
  }, {
    key: "renderForm",
    value: function renderForm() {
      var isSubmitted = this.state.isSubmitted;
      if (isSubmitted) {
        return /*#__PURE__*/React.createElement(HearingTestInvitationFormSubmitted, {
          data: this.props.settings
        });
      }
      return /*#__PURE__*/React.createElement(HearingTestInvitationForm, {
        language: this.language,
        data: this.props.settings,
        submitCallback: this.submitCallback.bind(this)
      });
    }
  }, {
    key: "render",
    value: function render() {
      var isConfirmationToken = this.state.isConfirmationToken;
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: "container-fluid invitation-container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "flex-row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-12"
      }, isConfirmationToken ? this.renderConfirmationOrError() : this.renderForm())))));
    }
  }], [{
    key: "getUrlParameter",
    value: function getUrlParameter(name) {
      var results = new RegExp("[?&]".concat(name, "=([^&#]*)")).exec(window.location.href);
      if (results === null) {
        return null;
      }
      return decodeURI(results[1]) || 0;
    }
  }]);
}(React.Component);
export default ReactHOC(HearingTestInvitationApp);